import builder from '../builder';
import SingleNeutralActionsEdit2 from '../../streamline-icons/bold/single-neutral-actions-edit-2.svg';

export default builder(
  'IconSingleNeutralActionsEdit2Bold',
  SingleNeutralActionsEdit2,
);
